// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__0n9P7","restartButton":"NotFound_restartButton__f1-MA"};